import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Bell, IndianRupee } from "lucide-react";

const fmt = (s) => new Date(s).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

export default function StaffBell({ variant = "desktop" }) {
  const [d, setD] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const nav = useNavigate();
  const load = () => api.get("/notifications").then(r => setD(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);
  useEffect(() => { const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }; document.addEventListener("mousedown", h); return () => document.removeEventListener("mousedown", h); }, []);
  const toggle = () => { setOpen(o => !o); if (!open && d.unread) api.post("/notifications/read").then(load).catch(() => {}); };
  return (
    <div className="relative" ref={ref} data-testid={`staff-bell-${variant}`}>
      <button onClick={toggle} data-testid={`staff-bell-btn-${variant}`} className="relative p-2 border border-zinc-200 bg-white hover:bg-zinc-100 transition-colors" aria-label="Notifications">
        <Bell size={15} />
        {d.unread ? <span data-testid={`staff-bell-count-${variant}`} className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 bg-rose-600 text-white text-[10px] font-bold grid place-items-center">{d.unread}</span> : null}
      </button>
      {open ? (
        <div data-testid="staff-bell-panel" className="absolute right-0 mt-1 w-80 max-h-96 overflow-y-auto bg-white border border-zinc-200 shadow-xl z-50">
          {d.items.length ? d.items.map(n => (
            <button key={n.id} data-testid={`staff-notif-${n.id}`} onClick={() => { setOpen(false); if (n.link) nav(n.link); }} className={`w-full text-left px-3 py-2.5 border-b border-zinc-100 text-xs hover:bg-zinc-50 ${n.read ? "" : "bg-emerald-50/70"}`}>
              <div className="font-semibold flex items-center gap-1.5">{n.kind === "khata_payment" ? <IndianRupee size={11} className="text-emerald-700" /> : null}{n.title}</div>
              <div className="text-zinc-600">{n.body}</div>
              <div className="text-[10px] text-zinc-400 mt-0.5">{fmt(n.created_at)}</div>
            </button>
          )) : <div className="p-6 text-center text-xs text-zinc-500">No notifications yet.</div>}
        </div>
      ) : null}
    </div>
  );
}
